<template>
  <ul
    :class="['i-tree', `i-tree-level-${level}`]"
    :role="level === 0 ? 'tree' : 'group'"
  >
    <i-tree-item
      v-for="item in items"
      :key="item.id"
      :item="item"
      :level="level"
      :expandable="treeContext.isExpandable(item)"
      :status="treeContext.status(item)"
      @toggle="treeContext.toggleItem"
      @expand="treeContext.expandItem"
      @collapse="treeContext.collapseItem"
      :expanded="treeContext.isExpanded(item)"
      @select="treeContext.selectItem"
      :selected="treeContext.isSelected(item)"
      :focusable="treeContext.isFocusable(item)"
      @navUp="treeContext.navUp"
      @navDown="treeContext.navDown"
      @navRight="treeContext.navRight"
      @navLeft="treeContext.navLeft"
      v-slot="scope"
    >
      <slot v-bind="scope" />
    </i-tree-item>
  </ul>
</template>

<script>
import TreeItem from './TreeItem.vue';

export default {
  name: 'i-tree',
  components: {
    [TreeItem.name]: TreeItem,
  },
  inject: ['$treeContext'],
  computed: {
    treeContext() {
      return typeof this.$treeContext === 'function' ? this.$treeContext() : null;
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    level: {
      type: Number,
      default: 0,
    },
  },
};

</script>
